import { configureStore } from '@reduxjs/toolkit';
import uiReducer from './slices/uiSlice';
import authReducer from '../features/auth/authSlice'; // 稍後會建立

export const store = configureStore({
    reducer: {
        ui: uiReducer,
        auth: authReducer, // 整合認證 slice
    },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;